import { LEAD_TYPES, PRODUCT_CATEGORY } from '@shared/constants';

export const getProductCategoryFromLeadType = (
  type: LEAD_TYPES
): PRODUCT_CATEGORY | null => {
  switch (type) {
    case LEAD_TYPES.COMPANY_GROUP:
      return PRODUCT_CATEGORY.GROUP;

    case LEAD_TYPES.INDIVIDUAL:
      return PRODUCT_CATEGORY.INDIVIDUAL;

    default:
      return null;
  }
};

export const getLeadTypeFromProductCategory = (
  type: PRODUCT_CATEGORY
): LEAD_TYPES | null => {
  switch (type) {
    case PRODUCT_CATEGORY.GROUP:
      return LEAD_TYPES.COMPANY_GROUP;

    case PRODUCT_CATEGORY.INDIVIDUAL:
      return LEAD_TYPES.INDIVIDUAL;

    default:
      return null;
  }
};
